import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { PLATFORM_DP_ENVIRONMENT } from '@jfw/angular/shared/tokens';
import { EzTuxInvoice } from '@jfw/types';
import { catchError, map, Observable, of } from 'rxjs';
import { WholesaleRviDocumentService } from '../rvi-document/rvi-document.service';

type InvoicesResult = {
  success: boolean;
  data: EzTuxInvoice[];
};

@Injectable({
  providedIn: 'root',
})
export class WholesaleBillingHistoryService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(PLATFORM_DP_ENVIRONMENT);
  private readonly rviDocumentService = inject(WholesaleRviDocumentService);
  private readonly invoicesApiUrl = this.environment.invoices_api_server_url;

  public getInvoices(accountNumber: string): Observable<InvoicesResult> {
    return this.http
      .get<EzTuxInvoice[]>(`${this.invoicesApiUrl}/${accountNumber}`, {
        ...requireAppCheck,
      })
      .pipe(
        map((data) => ({
          success: true,
          data,
        })),
        catchError((error) => {
          console.error(error);
          return of({ success: false, data: [] });
        }),
      );
  }

  public getInvoiceDocumentUrl(
    accountNumber: string,
    filename: string,
  ): Promise<string> {
    return this.rviDocumentService.getDocumentUrl(accountNumber, filename);
  }
}
